import { render, staticRenderFns } from "./SolanRubricsTable.vue?vue&type=template&id=3a17fa4c&scoped=true&"
import script from "./SolanRubricsTable.vue?vue&type=script&lang=ts&"
export * from "./SolanRubricsTable.vue?vue&type=script&lang=ts&"
import style0 from "./SolanRubricsTable.vue?vue&type=style&index=0&id=3a17fa4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a17fa4c",
  null
  
)

export default component.exports